import { jsx as _jsx } from "react/jsx-runtime";
import { useMessageContext } from "./MessageContext.js";
import { usePlasmicCanvasContext } from "@plasmicapp/host";
export const LGMessageProps = {
    previewLevel: {
        type: "choice",
        options: ["INFO", "NOTICE", "SUCCESS", "ERROR"],
        defaultValue: "NOTICE",
        displayName: "Preview Level",
    },
    previewContent: {
        type: "string",
        displayName: "Preview Message",
    },
};
export function LGMessage({ previewLevel, previewContent, className }) {
    const { message } = useMessageContext();
    const inEditor = usePlasmicCanvasContext();
    if (message?.messageType === "preset") {
        throw new Error("Preset messages are not yet supported in LGFlashMessage");
    }
    const level = message?.messageLevel || previewLevel;
    const content = message?.content || previewContent;
    const shouldShow = (message?.messageLevel && message?.content) || inEditor;
    if (!shouldShow) {
        return null;
    }
    //TODO: implement auto-hiding after a few seconds?
    return (_jsx("div", { className: `${className} lg-flash-message lg-message-${level.toLowerCase()}`, children: content }));
}
